import React from 'react';
import styles from './index.less';

const MessageRedbookLead = props => {
  const { data = {} } = props;
  const { image, title } = data;

  return (
    <div className={styles.card}>
      <div style={{ fontSize: '12px', color: '#9095AB', marginBottom: '8px' }}>留资卡</div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img style={{ width: '40px', height: '40px', marginRight: '10px', borderRadius: '50%' }} src={image} alt='' />
        <div style={{ fontSize: '14px', color: '#1D2754' }}>{title}</div>
      </div>
    </div>
  );
};

export default MessageRedbookLead;
